import { TaskQueue } from 'owa-task-queue';
import { fetchAndCacheTokenFromServer } from '../getAccessTokenforResource';
import TokenResponse from 'owa-service/lib/contract/TokenResponse';

const MAX_NUM_OF_GET_ACCESS_TOKEN_REQUESTS = 3;
const DELAY_FOR_GET_ACCESS_TOKEN_REQUESTS = 500; /* Task Delay */

let getAccessTokenQueue: TaskQueue<QueueEntry>;

export interface QueueEntry {
    onFulfilled: Function;
    onRejected: Function;
    resource: string;
}

/**
 * This throttles GetAccessTokenForResource server requests
 * by adding a delay of 500 ms
 */
function getQueue(): TaskQueue<QueueEntry> {
    if (getAccessTokenQueue == null) {
        getAccessTokenQueue = new TaskQueue<QueueEntry>(
            MAX_NUM_OF_GET_ACCESS_TOKEN_REQUESTS,
            getAccessTokenForResourceTask,
            DELAY_FOR_GET_ACCESS_TOKEN_REQUESTS
        );
    }
    return getAccessTokenQueue;
}

/**
 * enqueue this resource string
 * along with a success and an error callback to TaskQueue
 */
export function enqueue(res: string): Promise<TokenResponse> {
    let onSuccess: () => void = null;
    let onFailure: () => void = null;
    /* tslint:disable-next-line:promise-must-complete */
    const tokenReponsePromise = new Promise<TokenResponse>(async (resolve, reject) => {
        onSuccess = resolve;
        onFailure = reject;
    });
    let entry: QueueEntry = {
        onFulfilled: onSuccess,
        onRejected: onFailure,
        resource: res,
    };
    getQueue().add(entry);
    return tokenReponsePromise;
}

/**
 * Task callback method to run when it is
 * this entry's turn to process
 */
export async function getAccessTokenForResourceTask(entry: QueueEntry): Promise<any> {
    fetchAndCacheTokenFromServer(entry.resource)
        .then((tokenResponse: TokenResponse) => {
            entry.onFulfilled(tokenResponse);
        })
        .catch(error => {
            entry.onRejected(error);
        });
}
